export const MARKETPLACE_DATE_SORT_OPTIONS = [
    { value: '', label: 'Recently added' },
    { value: 'Oldest', label: 'Oldest first' },
];

export const MARKETPLACE_PRICE_SORT_OPTIONS = [
    { value: '', label: 'Any' },
    { value: 'PriceLow', label: 'Low to high' },
    { value: 'PriceHigh', label: 'High to low' },
];

export const isPriceSort = (value) => value === 'PriceLow' || value === 'PriceHigh';

export const normalizeMarketplaceDateSort = (value) => (value === 'Oldest' ? 'Oldest' : '');

export const getMarketplacePriceSortValue = (sortBy) => (isPriceSort(sortBy) ? sortBy : '');
